import FullscreenError from 'src/components/FullscreenError'

function HostChangeMidMeeting({ role }: { role: 'host' | 'participant' }) {
  return (
    <>
      {role === 'host' ? (
        <FullscreenError
          message="You are the new host of the meeting. Please close the app and reopen to resume the session."
          header="Close and Reopen"
        />
      ) : (
        <FullscreenError
          message="You are no longer the meeting host. Please close the app and reopen to resume the session."
          header="Close and Reopen"
        />
      )}
    </>
  )
}

export default HostChangeMidMeeting
